import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from '../../theme';
import CompleteHeroWithHeader from './CompleteHeroWithHeader';
import IntegrationBanner from './IntegrationBanner';
import ProblemSection from './ProblemSection';
import HowItWorksSection from './HowItWorksSection';
import OurFeaturesSection from './OurFeaturesSection';
import DIYBenefitsSection from './DIYBenefitsSection';
import AllInOneSolutionSection from './AllInOneSolutionSection';
import MeasurableResultsSection from './MeasurableResultsSection';
import PricingPlansSection from './PricingPlansSection';
import FooterSection from './FooterSection';
import ContactUsPopup from './ContactUsPopup';
import AboutUsModal from './AboutUsModal';

const VisibeenLandingPage = () => {
  const [isContactOpen, setContactOpen] = React.useState(false);
  const [isAboutOpen, setAboutOpen] = React.useState(false);

  // Persist trialToken from marketing links (e.g. /?trialToken=...) so login/OAuth flows pick it up
  React.useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const token = params.get('trialToken') || params.get('trialtoken') || params.get('token') || null;
      const sig = params.get('sig') || params.get('signature') || null;
      if (token) {
        try { localStorage.setItem('came_from_trial', String(token)); } catch(_) {}
        try { localStorage.setItem('came_from_trial_ts', String(Date.now())); } catch(_) {}
        if (sig) {
          try { localStorage.setItem('came_from_trial_sig', String(sig)); } catch(_) {}
        }
        try { window.dispatchEvent(new Event('trialInviteSet')); } catch(_) {}
        console.log('[Landing] persisted trialToken from URL to localStorage', token);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  const handleContactOpen = () => setContactOpen(true);
  const handleContactClose = () => setContactOpen(false);

  const handleAboutOpen = () => setAboutOpen(true);
  const handleAboutClose = () => setAboutOpen(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ 
        minHeight: '100vh', 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        backgroundColor: '#0f172a' // dark slate background
      }}>
        <CompleteHeroWithHeader onAboutClick={handleAboutOpen} />
        <IntegrationBanner />
        <Box id="about"><ProblemSection /></Box>
        <HowItWorksSection />
        <Box id="features"><OurFeaturesSection /></Box>
        <DIYBenefitsSection />
        <AllInOneSolutionSection />
        <MeasurableResultsSection />
        <Box id="pricing"><PricingPlansSection /></Box>
        <FooterSection onContactClick={handleContactOpen} onAboutClick={handleAboutOpen} />
        <ContactUsPopup open={isContactOpen} onClose={handleContactClose} />
        <AboutUsModal open={isAboutOpen} onClose={handleAboutClose} />
      </Box>
    </ThemeProvider>
  );
};

export default VisibeenLandingPage;